<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<script>
import findIndex from "lodash/findIndex";
import {mapState} from 'pinia';
import {useAuthStore} from "@dutypay/store-modules";

export default {
  name: 'DeveloperSettings',
  computed: {
    ...mapState(useAuthStore, ['user']),
    renderDeveloperSettings() {
      return (findIndex(this.user.roles, (item) => {
        return item === 'global:admin' || item === 'global:developer'
      }) !== -1);
    }
  }
}
</script>

<template>
  <div>
    <h1>{{ t('developerSettings.title') }}</h1>
    <router-view v-if="renderDeveloperSettings"></router-view>
    <p v-else>{{ t('noPermission.label') }}</p>
  </div>
</template>

<i18n>
{
  "ar-AE": {
    "developerSettings": {
      "title": "إعدادات المطور"
    }
  },
  "ar-EG": {
    "developerSettings": {
      "title": "إعدادات المطور"
    }
  },
  "ar-SA": {
    "developerSettings": {
      "title": "إعدادات المطور"
    }
  },
  "de-DE": {
    "developerSettings": {
      "title": "Entwicklereinstellungen"
    }
  },
  "de-AT": {
    "developerSettings": {
      "title": "Entwicklereinstellungen"
    }
  },
  "de-CH": {
    "developerSettings": {
      "title": "Entwicklereinstellungen"
    }
  },
  "en-US": {
    "developerSettings": {
      "title": "Developer Settings"
    }
  },
  "en-GB": {
    "developerSettings": {
      "title": "Developer Settings"
    }
  },
  "it-IT": {
    "developerSettings": {
      "title": "Impostazioni sviluppatore"
    }
  },
  "fr-FR": {
    "developerSettings": {
      "title": "Paramètres du développeur"
    }
  },
  "es-ES": {
    "developerSettings": {
      "title": "Configuración de desarrollador"
    }
  },
  "pl-PL": {
    "developerSettings": {
      "title": "Ustawienia programisty"
    }
  },
  "nl-NL": {
    "developerSettings": {
      "title": "Ontwikkelaarsinstellingen"
    }
  },
  "bg-BG": {
    "developerSettings": {
      "title": "Настройки за програмисти"
    }
  },
  "bs-BA": {
    "developerSettings": {
      "title": "Postavke programera"
    }
  },
  "da-DK": {
    "developerSettings": {
      "title": "Udviklerindstillinger"
    }
  },
  "et-EE": {
    "developerSettings": {
      "title": "Arendaja seaded"
    }
  },
  "fi-FI": {
    "developerSettings": {
      "title": "Kehittäjän asetukset"
    }
  },
  "el-GR": {
    "developerSettings": {
      "title": "Ρυθμίσεις προγραμματιστή"
    }
  },
  "he-IL": {
    "developerSettings": {
      "title": "הגדרות מפתח"
    }
  },
  "ga-IE": {
    "developerSettings": {
      "title": "Socruithe Forbróra"
    }
  },
  "ja-JP": {
    "developerSettings": {
      "title": "開発者設定"
    }
  },
  "hr-HR": {
    "developerSettings": {
      "title": "Postavke programera"
    }
  },
  "lv-LV": {
    "developerSettings": {
      "title": "Izstrādātāja iestatījumi"
    }
  },
  "lt-LT": {
    "developerSettings": {
      "title": "Kūrėjo nustatymai"
    }
  },
  "pt-PT": {
    "developerSettings": {
      "title": "Configurações do desenvolvedor"
    }
  },
  "ro-RO": {
    "developerSettings": {
      "title": "Setări pentru dezvoltatori"
    }
  },
  "ru-RU": {
    "developerSettings": {
      "title": "Настройки разработчика"
    }
  },
  "sv-SE": {
    "developerSettings": {
      "title": "Utvecklarinställningar"
    }
  },
  "sk-SK": {
    "developerSettings": {
      "title": "Nastavenia pre vývojárov"
    }
  },
  "cs-CZ": {
    "developerSettings": {
      "title": "Nastavení vývojáře"
    }
  },
  "tr-TR": {
    "developerSettings": {
      "title": "Geliştirici Ayarları"
    }
  },
  "hu-HU": {
    "developerSettings": {
      "title": "Fejlesztői beállítások"
    }
  },
  "fr-BE": {
    "developerSettings": {
      "title": "Paramètres du développeur"
    }
  },
  "fr-LU": {
    "developerSettings": {
      "title": "Paramètres du développeur"
    }
  },
  "mt-MT": {
    "developerSettings": {
      "title": "Settings tal-Iżviluppatur"
    }
  },
  "sl-SI": {
    "developerSettings": {
      "title": "Nastavitve za razvijalce"
    }
  },
  "el-CY": {
    "developerSettings": {
      "title": "Ρυθμίσεις προγραμματιστή"
    }
  },
  "tr-CY": {
    "developerSettings": {
      "title": "Geliştirici Ayarları"
    }
  },
  "uk-UA": {
    "developerSettings": {
      "title": "Налаштування Розробника"
    }
  },
  "zh-CN": {
    "developerSettings": {
      "title": "开发人员设定"
    }
  }
}
</i18n>
